// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	const checkpoint = 700;
	const checkpoint_2 = 100;
	
	window.addEventListener("scroll", () => {
	  const currentScroll = window.pageYOffset;
	
	  const elements = document.getElementsByClassName("scroll-effect-1");
	  for (var i = 0, len = elements.length; i < len; i++) {
		const currentPos = elements[i].getBoundingClientRect();
		const currentTop = window.innerHeight - currentPos.top;
		const currentRatio = currentTop / checkpoint;
		const opacity = 0 + currentRatio;
		elements[i].style.opacity = opacity;
	  }
	
	  const elements_2 = document.getElementsByClassName("menu-item");
	  const elements_3 = document.getElementsByClassName("p-2");
	
	  for (var i = 0, len = elements_3.length; i < len; i++) {
		if (currentScroll > window.innerHeight ) {
			// elements_2[i].style.color = '#002D5B';
			elements_3[i].style.fill = '#002D5B';

		} else {
			// elements_2[i].style.color = '#fff';
			elements_3[i].style.fill = '#fff'; 
		}
	
	
	  }
	  
	  
	
	});



} )();

( function() {
    console.log('hey');

    $(window).on("unload", function(e) {
        $('body').addClass('unload');
    });


	$(function () {
		$('#projectCarousel').carousel({interval: 500})
	});

    console.log('hey');

})(jQuery);